import { ScannerCodes } from '../enumerations/scanner-codes';

const escapeDictionary: { [id: string]: string } = {
  '%C': '[#x1d]',
  '\u001d': '[#x1d]',
  '%': '%',
};

export const escape = (value: string, scanDataType: number): string => {
  if (
    scanDataType === ScannerCodes.SCAN_SDT_UPDF417 ||
    scanDataType === ScannerCodes.SCAN_SDT_PDF417
  ) {
    let s = value.replace(new RegExp('p{Cc}+'), ''); //remove non printable characters , control characters
    s = s.replace('"', ''); //remove " double quote signs
    return s;
  }

  let escaped: string = value;
  for (const pair in escapeDictionary) {
    escaped = escaped.replace(pair, escapeDictionary[pair]);
  }
  return escaped;
};

export const removeSpecialCharacters = (value: string): string => {
  let escaped = value;
  for (const key in escapeDictionary) {
    escaped = escaped.replace(key, '');
    escaped = escaped.replace(escapeDictionary[key], '');
  }
  return escaped;
};

export const camelToKebab = (str: string): string => {
  return (
    str[0].toLowerCase() +
    str.slice(1, str.length).replace(/[A-Z]/g, letter => `-${letter.toLowerCase()}`)
  );
};
